export const COUNT_INFO = [
  {
    id: 1,
    title: 'all_cars',
    text: 'ماشین های ثبت شده',
    icon: 'icon-car',
  },
  {
    id: 2,
    title: 'today_cars',
    text: 'ماشین های ثبت شده امروز',
    icon: 'icon-car',
  },
  {
    id: 3,
    title: 'users',
    text: 'کاربران ثبت شده',
    icon: 'icon-profile-2user',
  },
]

export const asideIcons = {
  dashboard: 'icon-setting',
  cars: 'icon-car',
  products: 'icon-bag-happy',
  users: 'icon-profile-2user',
  categories: 'icon-category-2',
  sms: 'icon-sms',
}

export const asideTitles = {
  dashboard: 'داشبورد',
  cars: 'خودرو ها',
  products: 'محصولات',
  users: 'کاربران',
  categories: 'دسته بندی کاربران',
  sms: 'پنل اس ام اس',
}

export const asideProducts = [
  {
    id: 1,
    name: 'oil',
    title: 'تعویض روغن',
  },
  {
    id: 2,
    name: 'mechanical',
    title: 'مکانیکی',
  },
]
export const asideCars = [
  {
    id: 1,
    name: 'categories',
    title: 'دسته بندی خودرو',
  },
]

export const editCar = {
  car_model: '',
  color: '',
  monthly_ride: '',
  description: '',
  first: '',
  letter: '',
  second: '',
  state: '',
  aras_plate: '',
}

export const newCar = {
  code: '',
  car_model: '',
  color: '',
  monthly_ride: '',
  description: '',
  first: '',
  letter: '',
  second: '',
  state: '',
  aras_plate: '',
}

export const newProduct = {
  name: '',
  product: '',
}

export const newCategory = {
  value: '',
  color: '',
}

// const date = new Date()
//
// let day = date.getDate()
// let month = date.getMonth() + 1
// let year = date.getFullYear()
// let currentDate = `${year}/${month}/${day}`

export const userState = {
  full_name: '',
  gender: '',
  mobile: '',
  customer_type: '',
  birth_date: '',
  description: null,
}

export const loginState = {
  mobile: '',
  password: '',
}

export const SERVICE_LIST = [
  {
    id: 1,
    title: 'خدمات تعویض روغن',
  },
  {
    id: 2,
    title: 'خدمات مکانیکی',
  },
  {
    id: 3,
    title: 'خدمات لاستیک',
  },
  {
    id: 4,
    title: 'خدمات نظافتی',
  },
]

export const tireList = [
  {
    id: 1,
    label: 'جا اندازی لاستیک نو',
    service_category: 'خدمات لاستیک',
  },
  {
    id: 2,
    label: 'بالانس لاستیک',
    service_category: 'خدمات لاستیک',
  },
  {
    id: 3,
    label: 'جا به جایی لاستیک های عقب',
    service_category: 'خدمات لاستیک',
  },
]

export const cleanList = [
  {
    id: 1,
    label: 'صفرشویی کابین',
    service_category: 'خدمات نظافتی',
  },
  {
    id: 2,
    label: 'صفرشویی موتور',
    service_category: 'خدمات نظافتی',
  },
]

export const visitList = [
  { id: 'system_calc', value: 'سیستمی' },
  { id: '1', value: 'یک ماه' },
  { id: '2', value: 'دو ماه' },
  { id: '3', value: 'سه ماه' },
  { id: '4', value: 'چهار ماه' },
  { id: '5', value: 'پنج ماه' },
  { id: '6', value: 'شش ماه' },
  { id: '7', value: 'هفت ماه' },
  { id: '8', value: 'هشت ماه' },
  { id: '9', value: 'نه ماه' },
]

export const visitMonth = {
  system_calc: 'سیستمی',
  1: 'یک ماه بعد',
  2: 'دو ماه بعد',
  3: 'سه ماه بعد',
  4: 'چهار ماه بعد',
  5: 'پنج ماه بعد',
  6: 'شش ماه بعد',
  7: 'هفت ماه بعد',
  8: 'هشت ماه بعد',
  9: 'نه ماه بعد',
}

export const currentKmList = [
  1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 12000, 14000,
]

export const PAGES = ['dashboard', 'cars', 'products', 'users', 'categories', 'sms']
export const MOBILE_PAGES = ['dashboard', 'cars', 'users']

export const CategoriesTypesColors = [
  {
    id: 1,
    color: '#3F51B5',
  },
  {
    id: 2,
    color: '#673AB7',
  },
  {
    id: 3,
    color: '#F48FB1',
  },
  {
    id: 4,
    color: '#F44336',
  },
  {
    id: 5,
    color: '#2E7D32',
  },
  {
    id: 6,
    color: '#00BCD4',
  },
  {
    id: 7,
    color: '#81D4FA',
  },
  {
    id: 8,
    color: '#2196F3',
  },
  {
    id: 9,
    color: '#FF9800',
  },
  {
    id: 10,
    color: '#FFEB3B',
  },
  {
    id: 11,
    color: '#CDDC39',
  },
  {
    id: 12,
    color: '#8BC34A',
  },
  {
    id: 13,
    color: '#000000',
  },
  {
    id: 14,
    color: '#607D8B',
  },
  {
    id: 15,
    color: '#9E9E9E',
  },
  {
    id: 16,
    color: '#795548',
  },
]

/****************** custom class *************************/

export const position_center = 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
export const label_class = 'text-base font-normal mb-4 md:mb-6 dark:text-slate-50'
export const input_class =
  'bg-white rounded-md shadow shadow-add-more border border-input-border h-11 w-full mb-2 mt-2 px-3 focus:outline-none dark:border-slate-600 dark:bg-slate-800 dark:highlight-white/5 dark:hover:bg-slate-700 dark:text-amber-100'

export const select_class =
  'bg-white rounded-md shadow shadow-add-more border border-input-border h-11 w-full mb-2 mt-2 focus:outline-none dark:border-slate-600 dark:bg-slate-800 dark:text-amber-100 dark:placeholder-amber-100'

export const textarea_class =
  'bg-white rounded-md shadow shadow-add-more border border-input-border w-full mb-2 mt-2 px-3 focus:outline-none p-4 dark:border-slate-600 dark:bg-slate-800 dark:highlight-white/5 dark:hover:bg-slate-700 dark:text-amber-100'
export const badgeList = 'text-white bg-sky-400 text-sm font-medium mr-2 px-2.5 py-0.5 rounded'
export const transition_animation = 'ease-linear transition-all duration-150'

export const tab_button =
  'mb-4 sm:mb-0 w-1/2 sm:w-auto ml-0 text-tab p-1 border-b-2 border-b-transparent text-lg sm:ml-4'
export const active_tab_button = `mb-4 sm:mb-0 w-1/2 sm:w-auto ml-0 p-1 border-b-2 border-b-blue text-blue text-lg sm:ml-4 ${transition_animation}`

// export const
export const change_success = 'text-lg text-success flex items-center'
export const change_warning = 'text-lg text-warning flex items-center'

export const title_class = 'text-dark text-lg sm:text-xl font-bold dark:text-amber-50'

export const active_bg =
  'md:w-14 md:h-7 w-12 h-6 flex items-center rounded-full p-1 cursor-pointer bg-link'
export const inactive_bg =
  'md:w-14 md:h-7 w-12 h-6 flex items-center bg-gray-300 rounded-full p-1 cursor-pointer'
export const active_circle_bg =
  'bg-white md:w-6 md:h-6 h-5 w-5 rounded-full shadow-md transform -translate-x-6'
export const inactive_circle_bg =
  'bg-white md:w-6 md:h-6 h-5 w-5 rounded-full shadow-md transform translate-x-0'

export const inActiveData = 'px-6 py-4 text-gray-400 dark:text-slate-500'

export const brandsDiv =
  'bg-brand border border-brand-border dark:border-gray-700 rounded-md py-3 px-10 cursor-pointer dark:bg-slate-600 dark:text-gray-200'
export const activeBrandsDiv =
  'bg-blue text-white border border-brand-border rounded-md py-3 px-10 cursor-pointer'

export const desktop_navbar_class =
  'bg-white dark:bg-slate-800 border dark:border-l-gray-700 border-l-dark-100 min-h-screen fixed right-0 w-56'
export const mobile_navbar_class =
  'bg-white dark:bg-slate-800 border dark:border-t-gray-700 border-t-dark-100 fixed right-0 bottom-0 h-14 w-full z-10'

export const categoriesColors = 'w-11 h-11 rounded-full cursor-pointer m-auto border-[3px]'
export const categoriesActiveColor =
  'w-11 h-11 rounded-full cursor-pointer m-auto border-[3px] border-light-gray-page'

/****************** return schema errors *************************/
export const errorList = (err) => {
  let obj = {}
  err.inner.forEach((error_item) => {
    obj[error_item.path] = error_item?.message
  })
  return obj
}
